module.exports = __webpack_public_path__ + "static/media/  (51).27e067c0.jpg";